import {
  SET_INITIAL_LIVE_DATA,
  SET_LIVE_DATA,
} from '../../../../constants/centrifugo';

export const setInitialLiveData = (payload) => ({
  type: SET_INITIAL_LIVE_DATA,
  payload,
});

export const setLiveData = (payload) => ({
  type: SET_LIVE_DATA,
  payload,
});
